// @ts-nocheck
// ─────────────────────────────────────────────────────────────────────
// toast · Toast notifications
// ─────────────────────────────────────────────────────────────────────


const ICONS = {
  info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
  success: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>',
  warn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/></svg>',
  danger: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>',
};

let _stack = null;
let _counter = 0;
let _bridge = null;

/** Install a bridge so the legacy toast() calls the app's toast system instead of DOM toasts. */
export function installToastBridge(fn) {
  _bridge = fn;
}

export function clearToastBridge() {
  _bridge = null;
}

function _ensureStack() {
  if (_stack) return _stack;
  _stack = document.createElement('div');
  _stack.className = 'toast-stack';
  document.body.appendChild(_stack);
  return _stack;
}

/**
 * Show a toast.
 * @param {'info'|'success'|'warn'|'danger'} kind
 * @param {string} title
 * @param {string} [sub]
 * @param {number} [durationMs=4000] - 0 means no auto-dismiss
 * @param {Object} [options]
 * @param {{label: string, onClick: () => void}} [options.action] - Inline action button
 * @returns {number} Toast id (for manual dismiss)
 */
export function toast(kind, title, sub, durationMs = 4000, options = {}) {
  if (_bridge) {
    _bridge(kind, title, sub);
    return;
  }
  const stack = _ensureStack();
  const id = ++_counter;

  const el = document.createElement('div');
  el.className = `toast ${kind}`;
  el.dataset.id = id;
  const actionHTML = options.action
    ? `<button class="toast-action" data-toast-action>${options.action.label}</button>`
    : '';
  el.innerHTML = `
    <div class="toast-icon">${ICONS[kind] || ICONS.info}</div>
    <div class="toast-body">
      <div class="toast-title">${title}</div>
      ${sub ? `<div class="toast-sub">${sub}</div>` : ''}
    </div>
    ${actionHTML}
    <button class="toast-close" aria-label="Dismiss">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:12px;height:12px"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  `;
  el.querySelector('.toast-close').addEventListener('click', () => dismiss(id));
  if (options.action) {
    el.querySelector('[data-toast-action]').addEventListener('click', () => {
      try { options.action.onClick(); } catch (e) { console.error('toast action failed:', e); }
      dismiss(id);
    });
  }
  stack.appendChild(el);

  if (durationMs > 0) {
    setTimeout(() => dismiss(id), durationMs);
  }
  return id;
}

export function dismiss(id) {
  const el = _stack?.querySelector(`.toast[data-id="${id}"]`);
  if (!el) return;
  el.classList.add('toast-removing');
  setTimeout(() => el.remove(), 200);
}

// Expose on window for inline onclick handlers that haven't been refactored
if (typeof window !== 'undefined') window.toast = toast;
